import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { ErrorMessage } from '@priva/appshell';

import { SiteActions } from 'app/report-details/state/actions';
import { environment } from 'src/environments/environment';

import { SiteAsset } from './site.model';

@Injectable({
    providedIn: 'root',
})
export class SiteApiEffects {
    private readonly actions$ = inject(Actions);
    private readonly httpClient = inject(HttpClient);
    private readonly siteServiceUrl = `${environment.configuration.uris.siteService}`;

    getSites$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SiteActions.getSites),
            switchMap(() => {
                return this.httpClient.get<SiteAsset[]>(this.siteServiceUrl).pipe(
                    map((sites: SiteAsset[]) => {
                        return SiteActions.getSitesSuccess({ sites });
                    }),
                    catchError((error: ErrorMessage) => of(SiteActions.getSitesError({ error }))),
                );
            }),
        );
    });
}
